import { render, staticRenderFns } from "./TitleBlock.vue?vue&type=template&id=3b7d93e2&scoped=true"
import script from "./TitleBlock.vue?vue&type=script&lang=js"
export * from "./TitleBlock.vue?vue&type=script&lang=js"
import style0 from "./TitleBlock.vue?vue&type=style&index=0&id=3b7d93e2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d93e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b7d93e2')) {
      api.createRecord('3b7d93e2', component.options)
    } else {
      api.reload('3b7d93e2', component.options)
    }
    module.hot.accept("./TitleBlock.vue?vue&type=template&id=3b7d93e2&scoped=true", function () {
      api.rerender('3b7d93e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/TitleBlock.vue"
export default component.exports